import { themeColors } from "../../config";
export const GUIStyle = {
  section: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: themeColors.transparentBlack,
    borderRadius: 20,
    margin: 10,
    maxWidth: 800,
    minWidth: 200,
    transition: "width 0.2s",
  },
  title: {
    fontSize: 24,
    color: themeColors.optionTextColor,
    fontFamily: "roboto",
    margin: 10,
    textShadow: "0 0 5px white",
  },
  appBar: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    margin: 0,
    alignSelf: "stretch",
    justifyContent: "flex-start",
    flexWrap: "wrap",
  },
};
